import React from 'react';

export const Table = ({ children, className = '', ...props }) => {
  return (
    <div className="overflow-x-auto rounded-xl border border-azul-oscuro/10 bg-white shadow-lg">
      <table
        role="table"
        className={`w-full bg-white text-azul-oscuro border-collapse ${className}`}
        {...props}
      >
        {children}
      </table>
    </div>
  );
};

export const TableHeader = ({ children, className = '', ...props }) => {
  return (
    <thead
      role="rowgroup"
      className={`bg-azul-oscuro text-blanco-puro ${className}`}
      {...props}
    >
      {children}
    </thead>
  );
};

export const TableBody = ({ children, className = '', ...props }) => {
  return (
    <tbody
      role="rowgroup"
      className={`bg-blanco-puro divide-y divide-gris-piedra ${className}`}
      {...props}
    >
      {children}
    </tbody>
  );
};

export const TableRow = ({ children, className = '', ...props }) => {
  return (
    <tr
      role="row"
      className={`odd:bg-azul-oscuro/5 even:bg-white hover:bg-azul-oscuro/20 hover:text-azul-oscuro transition-colors duration-200 ${className}`}
      {...props}
    >
      {children}
    </tr>
  );
};

export const TableCell = ({ children, className = '', isHeader = false, ...props }) => {
  const Tag = isHeader ? 'th' : 'td'; // Decide si es una celda de encabezado o de cuerpo
  return (
    <Tag
      role={isHeader ? 'columnheader' : 'cell'}
      className={`p-4 text-left ${
        isHeader
          ? 'font-bold text-blanco-puro'
          : 'text-azul-oscuro'
      } border-b border-gris-piedra ${className}`}
      {...props}
    >
      {children}
    </Tag>
  );
};

export const TableHead = ({ children, className = '', scope = 'col', ...props }) => {
  return (
    <th
      role="columnheader"
      scope={scope}
      className={`p-4 text-left font-bold text-blanco-puro border-b border-amarillo-dorado ${className}`}
      {...props}
    >
      {children}
    </th>
  );
};
